var __TEMP__ = require('./_arraySample.js');var arraySample = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./values.js');var values = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * The base implementation of `_.sample`.
 *
 * @private
 * @param {Array|Object} collection The collection to sample.
 * @returns {*} Returns the random element.
 */
function baseSample(collection) {
  return arraySample(values(collection));
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = baseSample;
